/*  Klarithm — GSAP ScrollTrigger + Lottie animations  */

document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  /* ── Helper: default reveal ─────────────────────────── */
  function reveal(selector, vars) {
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    els.forEach(function (el) {
      gsap.from(el, Object.assign({
        y: 40,
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' }
      }, vars || {}));
    });
  }

  /* ── 2. Trust strip — stagger in ────────────────────── */
  var trustItems = document.querySelectorAll('.trust-strip-item');
  if (trustItems.length) {
    gsap.from(trustItems, {
      y: 20, opacity: 0, duration: 0.5, stagger: 0.1, ease: 'power2.out',
      scrollTrigger: { trigger: '.trust-strip', start: 'top 90%' }
    });
  }

  /* ── 3. Stats bar — count‑up numbers ────────────────── */
  var statNums = document.querySelectorAll('.stats-bar-num');
  statNums.forEach(function (el) {
    var raw = el.textContent.trim();
    var match = raw.match(/([\d,]+)/);
    if (!match) return;
    var target = parseInt(match[1].replace(/,/g, ''), 10);
    var prefix = raw.slice(0, raw.indexOf(match[1]));
    var suffix = raw.slice(raw.indexOf(match[1]) + match[1].length);

    el.textContent = prefix + '0' + suffix;
    var obj = { val: 0 };
    gsap.to(obj, {
      val: target,
      duration: 1.5,
      ease: 'power1.out',
      scrollTrigger: { trigger: el, start: 'top 90%' },
      onUpdate: function () {
        var v = Math.round(obj.val);
        el.textContent = prefix + v.toLocaleString() + suffix;
      }
    });
  });

  /* ── 4. Benefits cards — stagger ─────────────────────── */
  var benefitCards = document.querySelectorAll('.benefits-card');
  if (benefitCards.length) {
    gsap.from(benefitCards, {
      y: 50, opacity: 0, duration: 0.7, stagger: 0.15, ease: 'power2.out',
      scrollTrigger: { trigger: '.benefits-grid', start: 'top 80%' }
    });
  }

  /* ── 6. Mini social proof — slide in ────────────────── */
  var proofCards = document.querySelectorAll('.mini-proof-card');
  if (proofCards.length) {
    gsap.from(proofCards, {
      y: 30, opacity: 0, duration: 0.6, stagger: 0.2, ease: 'power2.out',
      scrollTrigger: { trigger: '.mini-proof-section', start: 'top 85%' }
    });
  }

  /* ── 7. Before / After — slide from sides ───────────── */
  var baWithout = document.querySelector('.beforeafter-without');
  var baWith = document.querySelector('.beforeafter-with');
  if (baWithout) {
    gsap.from(baWithout, {
      x: -60, opacity: 0, duration: 0.8, ease: 'power2.out',
      scrollTrigger: { trigger: '.beforeafter-section', start: 'top 75%' }
    });
  }
  if (baWith) {
    gsap.from(baWith, {
      x: 60, opacity: 0, duration: 0.8, ease: 'power2.out',
      scrollTrigger: { trigger: '.beforeafter-section', start: 'top 75%' }
    });
  }

  /* ── 8. How it works — stagger steps ────────────────── */
  var hiwSteps = document.querySelectorAll('.hiw-step');
  if (hiwSteps.length) {
    gsap.from(hiwSteps, {
      y: 40, opacity: 0, duration: 0.6, stagger: 0.2, ease: 'power2.out',
      scrollTrigger: { trigger: '.hiw-grid', start: 'top 80%' }
    });
  }

  /* ── 9. Why choose — stagger items ──────────────────── */
  var whyItems = document.querySelectorAll('.whychoose-item');
  if (whyItems.length) {
    gsap.from(whyItems, {
      y: 40, opacity: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out',
      scrollTrigger: { trigger: '.whychoose-grid', start: 'top 80%' }
    });
  }

  /* ── 10. Timeline — dots + content cascade ──────────── */
  var timelineItems = document.querySelectorAll('.timeline-item');
  timelineItems.forEach(function (item, i) {
    gsap.from(item.querySelector('.timeline-dot'), {
      scale: 0, duration: 0.4, ease: 'back.out(2)',
      scrollTrigger: { trigger: item, start: 'top 85%' }
    });
    gsap.from(item.querySelector('.timeline-content'), {
      x: 40, opacity: 0, duration: 0.6, ease: 'power2.out',
      scrollTrigger: { trigger: item, start: 'top 85%' }
    });
  });

  /* ── 11. Who cards — stagger ────────────────────────── */
  var whoCards = document.querySelectorAll('.who-card');
  if (whoCards.length) {
    gsap.from(whoCards, {
      y: 40, opacity: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out',
      scrollTrigger: { trigger: '.who-grid', start: 'top 80%' }
    });
  }

  /* ── 12. Review cards — stagger ─────────────────────── */
  var reviewCards = document.querySelectorAll('.review-card');
  if (reviewCards.length) {
    gsap.from(reviewCards, {
      y: 40, opacity: 0, duration: 0.6, stagger: 0.15, ease: 'power2.out',
      scrollTrigger: { trigger: '.reviews-grid', start: 'top 80%' }
    });
  }

  /* ── 13. Cost per serving cards — scale up ───────────── */
  var costCards = document.querySelectorAll('.costper-card');
  if (costCards.length) {
    gsap.from(costCards, {
      y: 50, opacity: 0, scale: 0.95, duration: 0.7, stagger: 0.2, ease: 'power2.out',
      scrollTrigger: { trigger: '.costper-grid', start: 'top 80%' }
    });
  }

  /* ── 14. Subscribe cards — stagger ──────────────────── */
  var subCards = document.querySelectorAll('.subsave-card');
  if (subCards.length) {
    gsap.from(subCards, {
      y: 40, opacity: 0, duration: 0.6, stagger: 0.15, ease: 'power2.out',
      scrollTrigger: { trigger: '.subsave-grid', start: 'top 80%' }
    });
  }

  /* ── 15. Story section ──────────────────────────────── */
  reveal('.story-headline');
  reveal('.story-body');
  var storyValues = document.querySelectorAll('.story-value');
  if (storyValues.length) {
    gsap.from(storyValues, {
      y: 30, opacity: 0, duration: 0.5, stagger: 0.1, ease: 'power2.out',
      scrollTrigger: { trigger: '.story-values', start: 'top 85%' }
    });
  }

  /* ── 16. Guarantee — scale up ───────────────────────── */
  var guarantee = document.querySelector('.guarantee-section');
  if (guarantee) {
    gsap.from(guarantee.querySelector('.guarantee-badge'), {
      scale: 0, duration: 0.5, ease: 'back.out(2)',
      scrollTrigger: { trigger: guarantee, start: 'top 80%' }
    });
    gsap.from(guarantee.querySelector('.guarantee-title'), {
      y: 30, opacity: 0, duration: 0.6, ease: 'power2.out',
      scrollTrigger: { trigger: guarantee, start: 'top 80%' }
    });
  }

  /* ── 17. Final CTA — fade up ────────────────────────── */
  reveal('.final-cta-title');
  reveal('.final-cta-actions', { delay: 0.2 });

  /* ── 18. Section headers — universal ────────────────── */
  reveal('.pdp-section-header:not(.no-anim)');
  reveal('.social-proof-header');

  /* ── 19. Comparison table ───────────────────────────── */
  reveal('.comparison-table-wrap', { y: 50, duration: 0.8 });

  /* ── 20. Press bar — fade in logos ────────────────────── */
  var pressLogos = document.querySelectorAll('.press-bar-logo');
  if (pressLogos.length) {
    gsap.from(pressLogos, {
      opacity: 0, duration: 0.5, stagger: 0.1, ease: 'power2.out',
      scrollTrigger: { trigger: '.press-bar-section', start: 'top 90%' }
    });
  }

  /* ── 21. Ingredients — stagger cards ────────────────── */
  var ingredientCards = document.querySelectorAll('.ingredient-card');
  if (ingredientCards.length) {
    gsap.from(ingredientCards, {
      y: 40, opacity: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out',
      scrollTrigger: { trigger: '.ingredients-grid', start: 'top 80%' }
    });
  }

  /* ── 22. Expert endorsements — static (no animation) ── */

  /* ── 23. Video section — fade in ────────────────────── */
  reveal('.video-player', { y: 50, duration: 0.8 });

  /* ── 24. Quiz teaser ────────────────────────────────── */
  reveal('.quizteaser-content', { y: 40 });


});
